import React from 'react';
import PayingAccountDF from '../components/SimulatorsComponents/DefualtSimulators/PayingAccountDF';
import { getSubCategoryId } from '../utils/DictionaryManagementUtils';

//= ========================================================================

const Sim_F08_RequestPaymentPayingAccount = ({
  globJSON,
  selectedScreen,
  simPlatform,
  slideshowRefs,
}) => (
  <PayingAccountDF
    globJSON={globJSON}
    selectedScreen={selectedScreen}
    simPlatform={simPlatform}
    withArrow
    isBlueBorder
    accountInfo={globJSON.configurations.services[getSubCategoryId(globJSON.screens[selectedScreen])].amount}
    slideshowRefs={slideshowRefs}
  />
);

export default Sim_F08_RequestPaymentPayingAccount;
